import { useState } from 'react'
import api from '../../utils/api'
import useToastContext from '../useToastContext'
import { notificationTypes } from '../../contexts/toastContext'

const useDoorbellsApi = () => {
  const addToast = useToastContext()

  const [doorbellsState, setDoorbellsState] = useState({
    doorbells: [],
    isLoading: false,
    error: null,
    success: false,
  })

  const [createDoorbellState, setCreateDoorbellState] = useState({
    isLoading: false,
    error: null,
  })

  const [updateDoorbellState, setUpdateDoorbellState] = useState({
    isLoading: false,
    error: null,
  })

  const [deleteDoorbellState, setDeleteDoorbellState] = useState({
    isLoading: false,
    error: null,
  })

  const [getDoorbellsFromBuildingState, setGetDoorbellsFromBuildingState] =
    useState({
      doorbells: [],
      isLoading: false,
      error: null,
    })

  const [doorbellGroupsState, setDoorbellGroupsState] = useState({
    groups: [],
    isLoading: false,
    error: null,
    success: false,
  })

  async function getDoorbells() {
    try {
      setDoorbellsState((currentDoorbellsState) => ({
        ...currentDoorbellsState,
        isLoading: true,
        error: null,
      }))
      const response = await api.get('/doorbells?showSurixType=true')
      setDoorbellsState({
        doorbells: [...doorbellsState.doorbells, ...response.data.data],
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setDoorbellsState({ doorbells: [], isLoading: false, error })
    }
  }

  async function createDoorbell(doorbell, isGate) {
    try {
      setCreateDoorbellState((currentCreateDoorbellState) => ({
        ...currentCreateDoorbellState,
        isLoading: true,
        error: null,
      }))
      const created = await api.post('/doorbells', doorbell)
      setCreateDoorbellState({
        isLoading: false,
        error: null,
      })
      setGetDoorbellsFromBuildingState({
        doorbells: [...getDoorbellsFromBuildingState.doorbells, created.data],
        isLoading: false,
        error: null,
      })
      addToast(
        notificationTypes.success,
        isGate ? 'Portón creado con exito!' : 'Portero creado con exito!'
      )
    } catch (error) {
      addToast(
        notificationTypes.error,
        isGate
          ? `Error al crear el portón: ${error.response.data.message}`
          : `Error al crear el portero: ${error.response.data.message}`
      )
      setCreateDoorbellState({ isLoading: false, error })
    }
  }

  async function updateImage(id, callback) {
    try {
      setGetDoorbellsFromBuildingState((currentCreateDoorbellState) => ({
        ...currentCreateDoorbellState,
        isLoading: true,
        error: null,
      }))
      await api.post(`/doorbells/${id}/updateImage`)
      setTimeout(() => {
        callback()
        setGetDoorbellsFromBuildingState({
          isLoading: false,
          error: null,
        })
        addToast(notificationTypes.success, 'Portero actualizado con exito!')
      }, 3000)
    } catch (error) {
      addToast(notificationTypes.error, `${error?.response?.data?.error}`)
      setGetDoorbellsFromBuildingState((currentCreateDoorbellState) => ({
        ...currentCreateDoorbellState,
        isLoading: false,
        error: error?.response?.data?.error,
      }))
    }
  }

  async function updateDoorbell(doorbell, isGate) {
    try {
      setUpdateDoorbellState((currentUpdateDoorbellState) => ({
        ...currentUpdateDoorbellState,
        isLoading: true,
        error: null,
      }))
      await api.put(`/doorbells/${doorbell.id}`, doorbell)
      setUpdateDoorbellState({
        isLoading: false,
        error: null,
      })
      setGetDoorbellsFromBuildingState({
        doorbells: getDoorbellsFromBuildingState.doorbells.map((elem) => {
          if (elem.id === doorbell.id) {
            return Object.assign({}, elem, doorbell)
          }
          return elem
        }),
        isLoading: false,
        error: null,
      })
      addToast(
        notificationTypes.success,
        isGate
          ? 'Portón actualizado con exito!'
          : 'Portero actualizado con exito!'
      )
    } catch (error) {
      addToast(
        notificationTypes.error,
        isGate
          ? `Error al actualizar el portón: ${error.response.data.message}`
          : `Error al actualizar el portero: ${error.response.data.message}`
      )
      setUpdateDoorbellState({ isLoading: false, error })
    }
  }

  async function deleteDoorbell(id, isGate) {
    try {
      setDeleteDoorbellState((currentDeleteDoorbellState) => ({
        ...currentDeleteDoorbellState,
        isLoading: true,
        error: null,
      }))
      await api.remove(`/doorbells/${id}`)
      setDeleteDoorbellState({
        isLoading: false,
        error: null,
      })
      setGetDoorbellsFromBuildingState({
        doorbells: getDoorbellsFromBuildingState.doorbells.filter(
          (elem) => elem.id !== id
        ),
        isLoading: false,
        error: null,
      })
      addToast(
        notificationTypes.success,
        isGate ? 'Portón borrado con exito!' : 'Portero borrado con exito!'
      )
    } catch (error) {
      addToast(
        notificationTypes.error,
        isGate
          ? `Error al borrar el portón: ${error.response.data.message}`
          : `Error al borrar el portero: ${error.response.data.message}`
      )
      setDeleteDoorbellState({ isLoading: false, error })
    }
  }

  async function getDoorbellsFromBuilding(buildingId) {
    try {
      setGetDoorbellsFromBuildingState(
        (currentGetDoorbellsFromBuildingsState) => ({
          ...currentGetDoorbellsFromBuildingsState,
          isLoading: true,
          error: null,
        })
      )
      const response = await api.get(
        `/buildings/${buildingId}/doorbells?showSurixType=true`
      )
      setGetDoorbellsFromBuildingState({
        doorbells: response.data.data,
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setGetDoorbellsFromBuildingState({
        doorbells: null,
        isLoading: false,
        error,
      })
    }
  }

  async function requestAccessDoorbell(id, code) {
    let response
    try {
      setCreateDoorbellState((currentCreateDoorbellState) => ({
        ...currentCreateDoorbellState,
        isLoading: true,
        error: null,
        success: false,
      }))
      response = await api.post(`/doorbells/${id}/requestAccess`, {
        code,
      })
      setCreateDoorbellState({
        isLoading: false,
        error: null,
        success: true,
      })
      setGetDoorbellsFromBuildingState({
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setCreateDoorbellState({
        isLoading: false,
        error: error?.response?.data,
        success: false,
      })
    }
  }

  async function updateSchedulesDoorbell(id) {
    try {
      setCreateDoorbellState((currentCreateDoorbellState) => ({
        ...currentCreateDoorbellState,
        isLoading: true,
        error: null,
        success: false,
      }))
      await api.post(`/doorbells/${id}/updateSchedules`, {})
      setCreateDoorbellState((currentCreateDoorbellState) => ({
        ...currentCreateDoorbellState,
        isLoading: false,
        error: null,
        success: true,
      }))
    } catch (error) {
      setCreateDoorbellState({
        isLoading: false,
        error: error?.response?.data,
        success: false,
      })
    }
  }

  async function getDoorbellGroups(buildingId) {
    try {
      setDoorbellGroupsState((currentDoorbellGroupsState) => ({
        ...currentDoorbellGroupsState,
        isLoading: true,
        error: null,
      }))
      const response = await api.get(`buildings/${buildingId}/doorbellGroups`)
      setDoorbellGroupsState({
        doorbellGroups: [...doorbellGroupsState.groups, ...response.data.data],
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setDoorbellGroupsState({ groups: [], isLoading: false, error })
    }
  }

  async function getDoobellSchedules() {
    try {
      setDoorbellsState((currentDoorbellsState) => ({
        ...currentDoorbellsState,
        isLoading: true,
        error: null,
      }))
      const response = await api.get('/doorbells/schedules')
      setDoorbellsState({
        doorbells: [...response.data],
        isLoading: false,
        error: null,
      })
    } catch (error) {
      setDoorbellsState({ doorbells: [], isLoading: false, error })
    }
  }

  async function cleanOneTime(id) {
    try {
      setDoorbellsState((currentDoorbellsState) => ({
        ...currentDoorbellsState,
        isLoading: true,
        error: null,
      }))
      await api.put(`/doorbells/${id}/cleanOneTime`)
      setDoorbellsState({
        isLoading: false,
        error: null,
      })
      getDoobellSchedules()
    } catch (error) {
      setDoorbellsState({ isLoading: false, error })
    }
  }

  async function cleanConcurrents(id) {
    try {
      setDoorbellsState((currentDoorbellsState) => ({
        ...currentDoorbellsState,
        isLoading: true,
        error: null,
      }))
      await api.put(`/doorbells/${id}/mergeConcurrent`)
      setDoorbellsState({
        isLoading: false,
        error: null,
      })
      getDoobellSchedules()
    } catch (error) {
      setDoorbellsState({ isLoading: false, error })
    }
  }

  const state = {
    doorbellsState,
    getDoorbellsFromBuildingState,
    createDoorbellState,
    doorbellGroupsState,
  }

  const methods = {
    getDoorbells,
    createDoorbell,
    updateDoorbell,
    deleteDoorbell,
    getDoorbellsFromBuilding,
    updateSchedulesDoorbell,
    updateImage,
    getDoorbellGroups,
    getDoobellSchedules,
    cleanOneTime,
    cleanConcurrents
  }

  return [state, methods]
}

export default useDoorbellsApi
